// import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { MobxProvider } from '@onpointwarranty/claims-design-system';
import getDomain from '@utils/GetDomain';

import AuthWrapper from '@components/AuthWrapper';
import App from './App';
import RootStore from './state/RootStore';

const root = ReactDOM.createRoot(document.getElementById('root'));

const mobxRootStore = RootStore();

const defaultKeycloakConfig = {
  realm: '',
  client_id: '',
  authority: '',
  redirect_uri: getDomain('', false),
};

function StrictMode({ enable = false, children }) {
  if (!enable) {
    return children;
  }
  return <React.StrictMode>{children}</React.StrictMode>;
}

root.render(
  <StrictMode enable={false}>
    <MobxProvider mobxRootStore={mobxRootStore}>
      <AuthWrapper defaultKeycloakConfig={defaultKeycloakConfig}>
        <App />
      </AuthWrapper>
    </MobxProvider>
  </StrictMode>,
);
